import Vue from 'vue';
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD_XxMD8VG-iokQW-FOGg27EJcarjevfAc',
    libraries: "places"
  }
});
